// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2DlE_","empty":"ModalGraph_empty__1cHLO"};